import * as React from 'react';

const SVGComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 9V6h12v3h2V6c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v3zm11 6-1.41-1.41L13 16.17V8h-2v8.17l-2.59-2.58L7 15l5 5z"
      fill="currentColor"
    />
  </svg>
);
export default SVGComponent;
